module.exports = ":host ::ng-deep .mobile app-chat-reply app-input-field .item.item-input .input-label {\r\n    display: none;\r\n}\r\n\r\n:host ::ng-deep .mobile app-chat-reply button {\r\n    font-size: 17px;\r\n    height: 2.2em;\r\n    padding: 0.1em;\r\n    margin: 0.5em 0.2em;\r\n}\r\n\r\n.threads {\r\n    padding: 2px 5px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/modal-commons/chat-frame/chat-frame.component.css
// module id = ./src/app/app_manager/modal/modal-commons/chat-frame/chat-frame.component.css
// module chunks = main